'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var debug = require('debug');

var log = debug('libp2p:secio');
log.error = debug('libp2p:secio:error');

var handshake = require('./handshake');

var State = require('./state');

var Wrap = require('it-pb-rpc');

var _require = require('it-length-prefixed'),
    int32BEDecode = _require.int32BEDecode,
    int32BEEncode = _require.int32BEEncode;

function secure(_x, _x2, _x3) {
  return _secure.apply(this, arguments);
}

function _secure() {
  _secure = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(localPeer, duplex, remotePeer) {
    var state, wrapped;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (localPeer) {
              _context.next = 2;
              break;
            }

            throw new Error('no local private key provided');

          case 2:
            if (duplex) {
              _context.next = 4;
              break;
            }

            throw new Error('no connection for the handshake provided');

          case 4:
            state = new State(localPeer, remotePeer);
            wrapped = Wrap(duplex, {
              lengthDecoder: int32BEDecode,
              lengthEncoder: int32BEEncode
            });
            _context.next = 8;
            return handshake(state, wrapped);

          case 8:
            return _context.abrupt("return", {
              conn: state.secure,
              remotePeer: state.id.remote
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _secure.apply(this, arguments);
}

module.exports = {
  protocol: '/secio/1.0.0',
  // since SECIO is symetric, we only need one function here
  secureInbound: secure,
  secureOutbound: secure
};